<template>
  <svg :class="['star-icon', customClass]" :viewBox="viewBox" :style="style" xmlns="http://www.w3.org/2000/svg">
    <polygon :points="starPoints" :fill="fill" />
  </svg>
</template>

<script>
import { STAR_POINTS, STAR_VIEWBOX } from '@/constants/stars';

export default {
  name: 'StarIcon',
  props: {
    fill: {
      type: String,
      default: '#ffc107' // Gold color
    },
    size: {
      type: Number,
      default: 28
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      starPoints: STAR_POINTS,
      viewBox: STAR_VIEWBOX
    };
  },
  computed: {
    style() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      };
    }
  }
};
</script>

<style scoped>
.star-icon {
  display: inline-block;
  flex-shrink: 0;
}
</style>

